import { get } from "@/services/axiosUitils";
import { axiosConfig } from "@/services/axiosConfig";

const basePath = "/pts_app/pts-onbonding-status";

export type OnboardingStatusType =
  | "onboarding_email_sent"
  | "perposal"
  | "perposal_signed"
  | "change_request"
  | "change_request_acknowledged"
  | "third_party_services_acknowledge";

export type OnboardingStatusValue = "pending" | "send";

export interface OnboardingStatusRecord {
  id: string;
  project_id: string;
  status_type: OnboardingStatusType | string;
  status: string;
  date: string | null;
  send_by: string | null;
  send_by_name?: string | null;
  notes?: string | null;
  [key: string]: unknown;
}

export interface CreateOnboardingStatusPayload {
  project_id: string;
  status_type: string;
  status: string;
  date: string;
  send_by: string;
  notes?: string;
}

export interface UpdateOnboardingStatusPayload {
  status?: string;
  date?: string;
  status_type?: string;
  send_by?: string;
  notes?: string;
}

function extractRecords(response: unknown): OnboardingStatusRecord[] {
  if (Array.isArray(response)) {
    return response as OnboardingStatusRecord[];
  }

  if (response && typeof response === "object") {
    const data = response as Record<string, unknown>;
    if (Array.isArray(data.results)) {
      return data.results as OnboardingStatusRecord[];
    }
    if (Array.isArray(data.data)) {
      return data.data as OnboardingStatusRecord[];
    }
    if (Array.isArray(data.items)) {
      return data.items as OnboardingStatusRecord[];
    }
  }

  return [];
}

class PtsOnboardingStatusService {
  /**
   * GET /pts_app/pts-onbonding-status/?project_id={projectId}
   */
  getByProjectId = async (
    projectId: string
  ): Promise<OnboardingStatusRecord[]> => {
    const response = await get<unknown>(`${basePath}/`, {
      params: { project_id: projectId },
    });
    return extractRecords(response);
  };

  /**
   * POST /pts_app/pts-onbonding-status/
   */
  create = async (
    payload: CreateOnboardingStatusPayload
  ): Promise<OnboardingStatusRecord> => {
    const response = await axiosConfig.post(`${basePath}/`, payload);
    return response.data;
  };

  /**
   * PATCH /pts_app/pts-onbonding-status/{id}/
   */
  update = async (
    id: string,
    payload: UpdateOnboardingStatusPayload
  ): Promise<OnboardingStatusRecord> => {
    const response = await axiosConfig.patch(`${basePath}/${id}/`, payload);
    return response.data;
  };
}

export default new PtsOnboardingStatusService();
